export const successCases = [
  {
    id: 'success-1',
    title: '처음 금 거래였는데 절차가 생각보다 간단했어요.',
    desc: '시세 확인부터 상품 선택, 수령 안내까지 한눈에 확인할 수 있어 안심하고 거래할 수 있었습니다.',
  },
  {
    id: 'success-2',
    title: '상품 비교와 시세 확인이 쉬워 구매 결정에 도움이 됐습니다.',
    desc: '중량과 가격 정보를 비교하며 원하는 금·은 상품을 빠르게 선택할 수 있었습니다.',
  },
  {
    id: 'success-3',
    title: '공식 인증 상품이라 믿고 구매할 수 있었습니다.',
    desc: '취급 브랜드와 인증 정보를 함께 확인할 수 있어 실물 자산 거래에 대한 신뢰감이 높았습니다.',
  },
]

export const columns = [
  {
    id: 'column-1',
    title: '배재한 ㈜골드나라 대표 "완전자산인 금, 정세 불안해질 수록 가치 상승"',
    source: '울산신문',
    date: '2026-03-15',
  },
  {
    id: 'column-2',
    title: '"투기가 아닌 미래를 지키는 투자."',
    source: '부산일보',
    date: '2025-12-15',
  },
  {
    id: 'column-3',
    title:
      '"금과 은 가격은 전쟁보다 통화량이 좌우··· / 추가 상승 가능성" 배재한 대표 "금 가격은 2001년 이후 장기 상승 ...',
    source: '주간동아',
    date: '2026-03-13',
  },
]
